import { PublicClientApplication } from "@azure/msal-browser";
import { config } from './lib/envConfig.js'

const msalConfig = {
  auth: {
    clientId: config?.VITE_CLIENT_ID,
    authority: "https://login.microsoftonline.com/" + config?.VITE_TENANT_ID,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
    secureCookies: false
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);